/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Faq_Q5Inputs */

const en_dr_faq_q5 = /** @type {(inputs: Dr_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a live, synchronous mode?`)
};

const id_dr_faq_q5 = /** @type {(inputs: Dr_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada mode langsung (live)?`)
};

/**
* | output |
* | --- |
* | "Is there a live, synchronous mode?" |
*
* @param {Dr_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_faq_q5 = /** @type {((inputs?: Dr_Faq_Q5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Faq_Q5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_faq_q5(inputs)
	return en_dr_faq_q5(inputs)
});